import type { ShopifyProduct } from '../types/ShopifyProduct';

export type FormattedShopifyProduct = {
  image: {
    src: string;
    altText: string;
  };
  title: string;
  shopItemUrl: string;
  price: string;
};


export function formatShopifyProductsForDisplay(products: ShopifyProduct[]): FormattedShopifyProduct[] {
  return products
    .filter(({ images }) => images.length > 0 && !!images[0])
    .map(({ images, title, shopItemUrl, price }) => ({
      image: {
        src: images[0].src,
        altText: images[0].alt
      },
      title,
      shopItemUrl,
      price
    }));
}

